<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3>
          <i class="fas fa-phone"></i> Ligações
        </h3>
      </div>
    </div>
    <Tables
      ref="tableGrid"
      :columns="[
        'ID da Ligação',
        'Telefone',
        'Agente',
        'Associado',
        'Ações'
      ]"
      :showNew="false"
      :showSearch="true"
      :showReload="true"
      :showTipFooter="false"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.callId">
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.callId ? obj.callId.toUpperCase() : '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.phoneNumber || '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.userUsername || '-'"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.associadoName ? obj.associadoName.toUpperCase() : '-'"
        />
        <TableColumn :IsCustom="true">
          <span
            v-b-tooltip.hover
            title="Download da gravação"
            @click="downloadRecording(obj.callId)"
            class="pointer"
          >
            <i class="fas fa-download icone-grid text-third"></i>
          </span>
        </TableColumn>
      </tr>
    </Tables>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ThreeCCallsRepository from '@/shared/http/repositories/threec/calls.js'
import ThreeCApiService from '@/shared/services/voip/ThreeCApiService'

export default {
  name: 'Ligacoes',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      ThreeCCallsRepository.getAllCalls({
        page: this.$refs.tableGrid.pagingIndex,
        size: this.$refs.tableGrid.pagingLimit
      })
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    onShowSearch (searchTerm) {
      this.filters = { searchTerm }
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    async downloadRecording (callId) {
      try {
        loading.push()
        const response = await ThreeCApiService.downloadRecording(callId)

        const blob = new Blob([response.data], { type: 'audio/mpeg' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `gravacao_${callId}.mp3`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        toast.success('Download iniciado!')
      } catch (error) {
        toast.error('Erro ao fazer download da gravação')
      } finally {
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/ligacoes/ligacoes.vue